import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import UserEmailMenu from './user_email_menu/user_email_menu';
import UserAvatar from './user_avatar/user_avatar';

import './app_bar_user_profile.scss';

export default function AppBarUserProfile(props) {
  return (
    <div className="app-bar-user-profile">
      <MediaQuery minDeviceWidth={800}>
        <UserEmailMenu {...props} />
      </MediaQuery>

      <MediaQuery maxDeviceWidth={799}>
        <UserAvatar {...props} />
      </MediaQuery>
    </div>
  );
}

AppBarUserProfile.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/app_bar_user_profile/app_bar_user_profile.jsx